export function setGalleryLinks() {
    let links = document.querySelectorAll('.pinfo__photolink')
    let projectImgs = document.querySelectorAll('.project-imgs')

    if (projectImgs.length > 0) {
        let span = document.createElement('span')
        span.setAttribute('id', 'photo-gallery')
        span.setAttribute('class', 'anchor-offset')
        projectImgs[0].insertAdjacentElement('beforebegin', span)

        links.forEach((link) => {
            link.setAttribute('href', `#photo-gallery`)
            link.classList.remove('hidden')
        })
    } else {
        links.forEach((link) => link.remove())
    }
}
